import { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Bookmark, FilePlus2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import OpportunityView, { MatchPanel } from "@/components/OpportunityView";

export default function OpportunityDetail() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const { orgId } = useAuth();
  const navigate = useNavigate();
  const [o, setO] = useState(null);
  const [projects, setProjects] = useState([]);
  const [pid, setPid] = useState(params.get("project") || "");
  useEffect(() => {
    if (!orgId) return;
    api.get(`/orgs/${orgId}/opportunities/${id}`, { params: { project_id: pid || undefined } }).then(({ data }) => {
      if (data.id !== id) navigate(`/app/funding/${data.id}${pid ? `?project=${pid}` : ""}`, { replace: true });
      else setO(data);
    }).catch((e) => toast.error(errMsg(e)));
    api.get(`/orgs/${orgId}/projects`).then(({ data }) => setProjects(data));
  }, [orgId, id, pid, navigate]);
  const toggleSave = async () => {
    try {
      if (o.saved) await api.delete(`/orgs/${orgId}/saved/${id}`);
      else await api.post(`/orgs/${orgId}/saved/${id}`);
      setO({ ...o, saved: !o.saved });
      toast.success(o.saved ? "Removed from saved" : "Saved - deadline reminders enabled");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const start = async () => {
    if (!pid) return toast.error("Select the project this application is for");
    try {
      const { data } = await api.post(`/projects/${pid}/applications`, { kind: "grant", opportunity_id: id });
      navigate(`/app/applications/${data.id}`);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  if (!o) return <p className="text-sm text-slate-500">Loading…</p>;
  return (
    <div className="space-y-6 fade-up">
      <Link to="/app/funding" className="text-sm text-[#0D9488] hover:underline">← Funding</Link>
      <div className="card flex flex-col gap-3 p-4 sm:flex-row sm:items-center">
        <label htmlFor="opp-project" className="text-sm font-medium">Project</label>
        <select id="opp-project" data-testid="opp-project-select" className="input sm:max-w-xs" value={pid} onChange={(e) => setPid(e.target.value)}>
          <option value="">Business profile only</option>{projects.map((p) => <option key={p.id} value={p.id}>{p.title}</option>)}
        </select>
      </div>
      <MatchPanel match={o.match} />
      <OpportunityView o={o} actions={<>
        <button onClick={toggleSave} data-testid="save-opportunity-button" className="btn-ghost btn-sm"><Bookmark className="h-4 w-4" />{o.saved ? "Saved" : "Save"}</button>
        <button onClick={start} disabled={o.status === "closed"} data-testid="start-grant-application-button" className="btn-teal btn-sm"><FilePlus2 className="h-4 w-4" />Prepare application</button>
      </>} />
    </div>
  );
}
